import { NotificationController } from "../controllers/notification.controller";
import { Router } from 'express'
import { authMiddleware } from "../../../middlewares/authMiddleware";
import { Routes } from "../../../interface/routes.interface";
export class NotificationRoute implements Routes {
    public path = '/notification'
    public notificationController = new NotificationController()
    public router = Router()

    constructor() {
        this.initializeRoutes()
    }
    public initializeRoutes() {
        this.router.get(`${this.path}/get`, authMiddleware, this.notificationController.getNotifications)
        this.router.post(`${this.path}/markAsRead/:notificationId`, this.notificationController.markAsRead)
        this.router.post(`${this.path}/markAsUnread/:notificationId`, this.notificationController.markAsUnread)
        this.router.delete(`${this.path}/delete`, authMiddleware, this.notificationController.deleteNotifications)
        this.router.delete(`${this.path}/delete/all`, authMiddleware, this.notificationController.deleteAllNotifications)
    }
}